/**
* @ngdoc directive
* @name Pie Chart
*
* @description
  Custom pie chart
*
* @scope
* @param {String} id - identifier
* @param {Array} data - data
* @param {Object} resize - resize on change
* @param {Boolean} legend
*
* @example
  <pie-chart
    id="transactionsChart"
    data='[{"id":627,"name":"Bakery","type":"category","sum":221.95},{"id":1671,"name":"Beverages","type":"category","sum":1328.18},{"id":628,"name":"Dairy","type":"category","sum":548.51},{"id":807,"name":"Desserts","type":"category","sum":149.45},{"id":629,"name":"Grocery","type":"category","sum":2195.31},{"id":630,"name":"Meat","type":"category","sum":1172.08},{"id":632,"name":"Produce","type":"category","sum":225.44},{"id":637,"name":"Seafood","type":"category","sum":48.13},{"id":634,"name":"Beer","type":"category","sum":277.71},{"id":635,"name":"Wine","type":"category","sum":57.37},{"id":1674,"name":"Poultry","type":"category","sum":0},{"id":1675,"name":"Liquor","type":"category","sum":0},{"id":1677,"name":"Other","type":"category","sum":0}]'
    resize="chartData"
    legend="true"
    tooltip="true"
    >
  </pie-chart>
*/

app.directive('pieChart', [function(){
  return {
    restrict: 'EA',
    scope: {
      id: '@',
      data: '=',
      resize: '=',
      legend: '@',
    },
    link: function (scope, element, attrs) {

      scope.onDataChange = function (data) {
        if (data && !_.isEmpty(data)){
          if (scope.drawn){
            return scope.update(data)
          } else {
            return scope.draw(data, element, attrs)
          }
        }
      }

      function resize() {
        if (scope.chart) scope.chart.resize()
      }

      scope.draw = function (data, element, attrs) {
        var width = element.parent().width()
          , height = width

        scope.chart = Vis.Svg.Chart.Pie({
          width: width
        , height: height
        , value: function (d) { return Math.round(d.sum) }
        , valueKey: 'sum'
        , format: d3.format('$0,000')
        , tooltip: true
        , legend: attrs.legend
        , sum: true
        })

        d3.select(element[0]).call(scope.chart)

        scope.chart.update(data)
        scope.drawn = true

        $(window).on('resize', function () {
          resize()
        })
      }

      scope.update = function (data) {
        scope.chart.update(data)
      }

      scope.$watch('data', scope.onDataChange, true)
      scope.$watch('resize', resize)
    }
  };
}])



// WEBPACK FOOTER //
// ./~/ng-annotate-loader/loader.js!./project/components/chartDirective.js